// Pathify
import {make} from 'vuex-pathify'
import api from "@/services/api";
import {toast} from '@/util/helpers';
import Models from "../../models";

// Data
const state = {
	articles:[],
	article: Models.Resource('Article'),
}

const getters = make.getters(state)

const mutations = make.mutations(state)

const actions = {
	...make.actions(state),
	getArticles: ({ dispatch }) => {
		api.articles.index()
			.then(response => dispatch('setArticles', response.data))
			.catch(error => toast.add(error.message, 'error'))
	},
	getArticle: ({ dispatch }, id) => {
		api.articles.show(id)
			.then(response => dispatch('setArticle', response.data))
			.catch(error => toast.add(error.message, 'error'))
	}

}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
}
